/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as CallbackRouteImport } from './routes/callback'
import { Route as AuthentikLoginRouteImport } from './routes/authentikLogin'
import { Route as AuthenticatedLayoutRouteImport } from './routes/_authenticated-layout'
import { Route as AuthenticatedLayoutIndexRouteImport } from './routes/_authenticated-layout/index'
import { Route as AuthenticatedLayoutTasksIndexRouteImport } from './routes/_authenticated-layout/tasks/index'
import { Route as AuthenticatedLayoutTaskGridIndexRouteImport } from './routes/_authenticated-layout/task-grid/index'
import { Route as AuthenticatedLayoutSearchIndexRouteImport } from './routes/_authenticated-layout/search/index'
import { Route as AuthenticatedLayoutRecordingsIndexRouteImport } from './routes/_authenticated-layout/recordings/index'
import { Route as AuthenticatedLayoutQcWidgetsIndexRouteImport } from './routes/_authenticated-layout/qc-widgets/index'
import { Route as AuthenticatedLayoutNotificationsIndexRouteImport } from './routes/_authenticated-layout/notifications/index'
import { Route as AuthenticatedLayoutGroupsIndexRouteImport } from './routes/_authenticated-layout/groups/index'
import { Route as AuthenticatedLayoutGroupGroupIdIndexRouteImport } from './routes/_authenticated-layout/group/$groupId/index'
import { Route as AuthenticatedLayoutGroupGroupIdItemFolderIdRouteImport } from './routes/_authenticated-layout/group/$groupId/item/$folderId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const CallbackRoute = CallbackRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthentikLoginRoute = AuthentikLoginRouteImport.update({
  id: '/authentikLogin',
  path: '/authentikLogin',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedLayoutRoute = AuthenticatedLayoutRouteImport.update({
  id: '/_authenticated-layout',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedLayoutIndexRoute =
  AuthenticatedLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutTasksIndexRoute =
  AuthenticatedLayoutTasksIndexRouteImport.update({
    id: '/tasks/',
    path: '/tasks/',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutTaskGridIndexRoute =
  AuthenticatedLayoutTaskGridIndexRouteImport.update({
    id: '/task-grid/',
    path: '/task-grid/',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutSearchIndexRoute =
  AuthenticatedLayoutSearchIndexRouteImport.update({
    id: '/search/',
    path: '/search/',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutRecordingsIndexRoute =
  AuthenticatedLayoutRecordingsIndexRouteImport.update({
    id: '/recordings/',
    path: '/recordings/',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutQcWidgetsIndexRoute =
  AuthenticatedLayoutQcWidgetsIndexRouteImport.update({
    id: '/qc-widgets/',
    path: '/qc-widgets/',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutNotificationsIndexRoute =
  AuthenticatedLayoutNotificationsIndexRouteImport.update({
    id: '/notifications/',
    path: '/notifications/',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutGroupsIndexRoute =
  AuthenticatedLayoutGroupsIndexRouteImport.update({
    id: '/groups/',
    path: '/groups/',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutGroupGroupIdIndexRoute =
  AuthenticatedLayoutGroupGroupIdIndexRouteImport.update({
    id: '/group/$groupId/',
    path: '/group/$groupId/',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutGroupGroupIdItemFolderIdRoute =
  AuthenticatedLayoutGroupGroupIdItemFolderIdRouteImport.update({
    id: '/group/$groupId/item/$folderId',
    path: '/group/$groupId/item/$folderId',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/authentikLogin': typeof AuthentikLoginRoute
  '/callback': typeof CallbackRoute
  '/login': typeof LoginRoute
  '/': typeof AuthenticatedLayoutIndexRoute
  '/groups': typeof AuthenticatedLayoutGroupsIndexRoute
  '/notifications': typeof AuthenticatedLayoutNotificationsIndexRoute
  '/qc-widgets': typeof AuthenticatedLayoutQcWidgetsIndexRoute
  '/recordings': typeof AuthenticatedLayoutRecordingsIndexRoute
  '/search': typeof AuthenticatedLayoutSearchIndexRoute
  '/task-grid': typeof AuthenticatedLayoutTaskGridIndexRoute
  '/tasks': typeof AuthenticatedLayoutTasksIndexRoute
  '/group/$groupId': typeof AuthenticatedLayoutGroupGroupIdIndexRoute
  '/group/$groupId/item/$folderId': typeof AuthenticatedLayoutGroupGroupIdItemFolderIdRoute
}
export interface FileRoutesByTo {
  '/authentikLogin': typeof AuthentikLoginRoute
  '/callback': typeof CallbackRoute
  '/login': typeof LoginRoute
  '/': typeof AuthenticatedLayoutIndexRoute
  '/groups': typeof AuthenticatedLayoutGroupsIndexRoute
  '/notifications': typeof AuthenticatedLayoutNotificationsIndexRoute
  '/qc-widgets': typeof AuthenticatedLayoutQcWidgetsIndexRoute
  '/recordings': typeof AuthenticatedLayoutRecordingsIndexRoute
  '/search': typeof AuthenticatedLayoutSearchIndexRoute
  '/task-grid': typeof AuthenticatedLayoutTaskGridIndexRoute
  '/tasks': typeof AuthenticatedLayoutTasksIndexRoute
  '/group/$groupId': typeof AuthenticatedLayoutGroupGroupIdIndexRoute
  '/group/$groupId/item/$folderId': typeof AuthenticatedLayoutGroupGroupIdItemFolderIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated-layout': typeof AuthenticatedLayoutRouteWithChildren
  '/authentikLogin': typeof AuthentikLoginRoute
  '/callback': typeof CallbackRoute
  '/login': typeof LoginRoute
  '/_authenticated-layout/': typeof AuthenticatedLayoutIndexRoute
  '/_authenticated-layout/groups/': typeof AuthenticatedLayoutGroupsIndexRoute
  '/_authenticated-layout/notifications/': typeof AuthenticatedLayoutNotificationsIndexRoute
  '/_authenticated-layout/qc-widgets/': typeof AuthenticatedLayoutQcWidgetsIndexRoute
  '/_authenticated-layout/recordings/': typeof AuthenticatedLayoutRecordingsIndexRoute
  '/_authenticated-layout/search/': typeof AuthenticatedLayoutSearchIndexRoute
  '/_authenticated-layout/task-grid/': typeof AuthenticatedLayoutTaskGridIndexRoute
  '/_authenticated-layout/tasks/': typeof AuthenticatedLayoutTasksIndexRoute
  '/_authenticated-layout/group/$groupId/': typeof AuthenticatedLayoutGroupGroupIdIndexRoute
  '/_authenticated-layout/group/$groupId/item/$folderId': typeof AuthenticatedLayoutGroupGroupIdItemFolderIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/authentikLogin'
    | '/callback'
    | '/login'
    | '/'
    | '/groups'
    | '/notifications'
    | '/qc-widgets'
    | '/recordings'
    | '/search'
    | '/task-grid'
    | '/tasks'
    | '/group/$groupId'
    | '/group/$groupId/item/$folderId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/authentikLogin'
    | '/callback'
    | '/login'
    | '/'
    | '/groups'
    | '/notifications'
    | '/qc-widgets'
    | '/recordings'
    | '/search'
    | '/task-grid'
    | '/tasks'
    | '/group/$groupId'
    | '/group/$groupId/item/$folderId'
  id:
    | '__root__'
    | '/_authenticated-layout'
    | '/authentikLogin'
    | '/callback'
    | '/login'
    | '/_authenticated-layout/'
    | '/_authenticated-layout/groups/'
    | '/_authenticated-layout/notifications/'
    | '/_authenticated-layout/qc-widgets/'
    | '/_authenticated-layout/recordings/'
    | '/_authenticated-layout/search/'
    | '/_authenticated-layout/task-grid/'
    | '/_authenticated-layout/tasks/'
    | '/_authenticated-layout/group/$groupId/'
    | '/_authenticated-layout/group/$groupId/item/$folderId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedLayoutRoute: typeof AuthenticatedLayoutRouteWithChildren
  AuthentikLoginRoute: typeof AuthentikLoginRoute
  CallbackRoute: typeof CallbackRoute
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/callback': {
      id: '/callback'
      path: '/callback'
      fullPath: '/callback'
      preLoaderRoute: typeof CallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/authentikLogin': {
      id: '/authentikLogin'
      path: '/authentikLogin'
      fullPath: '/authentikLogin'
      preLoaderRoute: typeof AuthentikLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated-layout': {
      id: '/_authenticated-layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated-layout/': {
      id: '/_authenticated-layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedLayoutIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated-layout/tasks/': {
      id: '/_authenticated-layout/tasks/'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof AuthenticatedLayoutTasksIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated-layout/task-grid/': {
      id: '/_authenticated-layout/task-grid/'
      path: '/task-grid'
      fullPath: '/task-grid'
      preLoaderRoute: typeof AuthenticatedLayoutTaskGridIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated-layout/search/': {
      id: '/_authenticated-layout/search/'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof AuthenticatedLayoutSearchIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated-layout/recordings/': {
      id: '/_authenticated-layout/recordings/'
      path: '/recordings'
      fullPath: '/recordings'
      preLoaderRoute: typeof AuthenticatedLayoutRecordingsIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated-layout/qc-widgets/': {
      id: '/_authenticated-layout/qc-widgets/'
      path: '/qc-widgets'
      fullPath: '/qc-widgets'
      preLoaderRoute: typeof AuthenticatedLayoutQcWidgetsIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated-layout/notifications/': {
      id: '/_authenticated-layout/notifications/'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AuthenticatedLayoutNotificationsIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated-layout/groups/': {
      id: '/_authenticated-layout/groups/'
      path: '/groups'
      fullPath: '/groups'
      preLoaderRoute: typeof AuthenticatedLayoutGroupsIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated-layout/group/$groupId/': {
      id: '/_authenticated-layout/group/$groupId/'
      path: '/group/$groupId'
      fullPath: '/group/$groupId'
      preLoaderRoute: typeof AuthenticatedLayoutGroupGroupIdIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated-layout/group/$groupId/item/$folderId': {
      id: '/_authenticated-layout/group/$groupId/item/$folderId'
      path: '/group/$groupId/item/$folderId'
      fullPath: '/group/$groupId/item/$folderId'
      preLoaderRoute: typeof AuthenticatedLayoutGroupGroupIdItemFolderIdRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
  }
}

interface AuthenticatedLayoutRouteChildren {
  AuthenticatedLayoutIndexRoute: typeof AuthenticatedLayoutIndexRoute
  AuthenticatedLayoutGroupsIndexRoute: typeof AuthenticatedLayoutGroupsIndexRoute
  AuthenticatedLayoutNotificationsIndexRoute: typeof AuthenticatedLayoutNotificationsIndexRoute
  AuthenticatedLayoutQcWidgetsIndexRoute: typeof AuthenticatedLayoutQcWidgetsIndexRoute
  AuthenticatedLayoutRecordingsIndexRoute: typeof AuthenticatedLayoutRecordingsIndexRoute
  AuthenticatedLayoutSearchIndexRoute: typeof AuthenticatedLayoutSearchIndexRoute
  AuthenticatedLayoutTaskGridIndexRoute: typeof AuthenticatedLayoutTaskGridIndexRoute
  AuthenticatedLayoutTasksIndexRoute: typeof AuthenticatedLayoutTasksIndexRoute
  AuthenticatedLayoutGroupGroupIdIndexRoute: typeof AuthenticatedLayoutGroupGroupIdIndexRoute
  AuthenticatedLayoutGroupGroupIdItemFolderIdRoute: typeof AuthenticatedLayoutGroupGroupIdItemFolderIdRoute
}

const AuthenticatedLayoutRouteChildren: AuthenticatedLayoutRouteChildren = {
  AuthenticatedLayoutIndexRoute: AuthenticatedLayoutIndexRoute,
  AuthenticatedLayoutGroupsIndexRoute: AuthenticatedLayoutGroupsIndexRoute,
  AuthenticatedLayoutNotificationsIndexRoute:
    AuthenticatedLayoutNotificationsIndexRoute,
  AuthenticatedLayoutQcWidgetsIndexRoute:
    AuthenticatedLayoutQcWidgetsIndexRoute,
  AuthenticatedLayoutRecordingsIndexRoute:
    AuthenticatedLayoutRecordingsIndexRoute,
  AuthenticatedLayoutSearchIndexRoute: AuthenticatedLayoutSearchIndexRoute,
  AuthenticatedLayoutTaskGridIndexRoute: AuthenticatedLayoutTaskGridIndexRoute,
  AuthenticatedLayoutTasksIndexRoute: AuthenticatedLayoutTasksIndexRoute,
  AuthenticatedLayoutGroupGroupIdIndexRoute:
    AuthenticatedLayoutGroupGroupIdIndexRoute,
  AuthenticatedLayoutGroupGroupIdItemFolderIdRoute:
    AuthenticatedLayoutGroupGroupIdItemFolderIdRoute,
}

const AuthenticatedLayoutRouteWithChildren =
  AuthenticatedLayoutRoute._addFileChildren(AuthenticatedLayoutRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedLayoutRoute: AuthenticatedLayoutRouteWithChildren,
  AuthentikLoginRoute: AuthentikLoginRoute,
  CallbackRoute: CallbackRoute,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
